/*
 * action types
 */

export const SET_PROJECTS = 'SET_PROJECTS';

/*
 * action creators
 */

export function setProjects(projects) {
  return {
    type: SET_PROJECTS,
    projects
  };
}



// WEBPACK FOOTER //
// ./src/actions/project.js